export const licenseKeys: { [key: string]: number } = {
  Akron: 140094,
  Cleveland: 140094,
  Cincinnati: 140097,
  Columbus: 140098,
  Dayton: 140098,
};
